var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramUtilityWater64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./UtilityWater64*",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Water",
    transform: "translate(9.000000, 12.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45,38.428648 C45,40.9535257 43.2089412,43 40.9997656,43 C38.79059,43 37,40.9535257 37,38.428648 C37,35.9037702 40.9997656,27 40.9997656,27 C40.9997656,27 45,35.9037702 45,38.428648 Z",
    id: "Drop",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Tap",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Support",
    transform: "translate(23.500000, 6.000000) scale(-1, 1) translate(-23.500000, -6.000000) ",
    points: "22 10 22 2 25 2 25 10"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Focus",
    x: 15,
    y: 0,
    width: 17,
    height: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Pipe",
    points: "0 10 46 10 46 28 36 28 36 20 0 20"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramUtilityWater64);
export default __webpack_public_path__ + "static/media/pictogramUtilityWater64.69de36be4d4cc1d157722675d4bc4788.svg";
export { ForwardRef as ReactComponent };